export function getOrders ({ state, commit }, { comanda_nr, clientkey, erp, datefrom, dateto, page = 1}) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/orders', { params: { comanda_nr, clientkey, erp, datefrom, dateto, page } })
      .then((response) => {
        if (response.data.orders_cart || response.data.orders_deviz) {
          commit('setOrders', response.data)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getOrder ({ state, commit }, { order_id, type }) {
  return new Promise((resolve, reject) => {
    if (order_id) {
      axiosInstance.get('/v1/orders/' + order_id, { params: { type } })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Missing order id'))
    }
  })
}

export function getOrdersExport ({ state, commit }, { comanda_nr, clientkey, erp, datefrom, dateto}) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/orders/export', { params: { comanda_nr, clientkey, erp, datefrom, dateto } })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
